import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination';
import type { PaginationConfig } from '../shared/types/rate-shop-types';

interface TablePaginationProps {
  paginationConfig: PaginationConfig;
  onPageChange: (page: number) => void;
  onPrevious: () => void;
  onNext: () => void;
}

export const TablePagination = ({
  paginationConfig,
  onPageChange,
  onPrevious,
  onNext,
}: TablePaginationProps) => {
  const { currentPage, totalPages } = paginationConfig;

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className='flex justify-center mt-4'>
      <Pagination>
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              onClick={(e) => {
                e.preventDefault();
                onPrevious();
              }}
              className={currentPage === 1 ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
            />
          </PaginationItem>

          {/* Show first few pages */}
          {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => i + 1).map((pageNum) => (
            <PaginationItem key={pageNum}>
              <PaginationLink
                onClick={(e) => {
                  e.preventDefault();
                  onPageChange(pageNum);
                }}
                isActive={currentPage === pageNum}
                className='cursor-pointer'
              >
                {pageNum}
              </PaginationLink>
            </PaginationItem>
          ))}

          {/* Show ellipsis and last page if there are more than 5 pages */}
          {totalPages > 5 && (
            <>
              <PaginationItem>
                <PaginationEllipsis />
              </PaginationItem>
              <PaginationItem>
                <PaginationLink
                  onClick={(e) => {
                    e.preventDefault();
                    onPageChange(totalPages);
                  }}
                  isActive={currentPage === totalPages}
                  className='cursor-pointer'
                >
                  {totalPages}
                </PaginationLink>
              </PaginationItem>
            </>
          )}

          <PaginationItem>
            <PaginationNext
              onClick={(e) => {
                e.preventDefault();
                onNext();
              }}
              className={
                currentPage === totalPages ? 'pointer-events-none opacity-50' : 'cursor-pointer'
              }
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  );
};
